import React from 'react';

const CalendarIcon = ({ color = '#46446F', size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.6667 3.33334H2.33335C1.41288 3.33334 0.666687 4.07954 0.666687 5.00001V16.6667C0.666687 17.5872 1.41288 18.3333 2.33335 18.3333H15.6667C16.5872 18.3333 17.3334 17.5872 17.3334 16.6667V5.00001C17.3334 4.07954 16.5872 3.33334 15.6667 3.33334Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.3334 1.66666V4.99999" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.66669 1.66666V4.99999" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.666687 8.33334H17.3334" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default CalendarIcon;
